<div class="notification error-msg" *ngIf="disableMFAConfiguration && (!isUserAuthorizedViaSchoolPassport || userIsMissingOnETX)">
    <p>
        <mat-icon>error</mat-icon>
        <span *ngIf="!isUserAuthorizedViaSchoolPassport">To manage MFA settings, <span class="notification-action-link font-weight-500" (click)="redirectToSchoolPassport()">click here</span> to log in via {{customerShortName}}.</span>
        <span *ngIf="userIsMissingOnETX">MFA user settings could not be loaded. Please wait - it may take some time before you can edit them.</span>
    </p>
</div>

<div *ngIf="infoMsg" class="notification info-msg">
    <p>
        <mat-icon>info</mat-icon> {{infoMsg}}
    </p>
</div>

<div>
    <h3 class="title">Change Password</h3>
    <p>Create a new password for your account. For security, choose a strong password that you don't use for other accounts.</p>

    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="secondary-text">
            <ng-container *ngIf="currentUser?.lastPasswordChanged">Last changed: <span>{{currentUser?.lastPasswordChanged | datePlusGMTPipe: 'short'}}</span></ng-container>
        </div>

        <button mat-raised-button
                color="primary"
                (click)="onChangePassword()"
        >
            Change Password
        </button>
    </div>
</div>

<ng-container *ngIf="!disableMFAConfiguration">
    <ngc-user-mfa-settings [user]="currentUser"
                           [userOrg]="currentOrg"
                           (hasRecoveryCodes)="hasRecoveryCodes = $event"
                           class="user-password-change"
    >
    </ngc-user-mfa-settings>

    <div *ngIf="hasRecoveryCodes">
        <h3 class="title">Recovery Codes</h3>
        <p>Use recovery codes if you lose access to your authenticator app or phone. You can generate new codes at any time. Old codes will stop working immediately.</p>

        <p class="data-header pt-16 text-right">
            <span class="input-name"></span>
            <button mat-raised-button
                    color="primary"
                    (click)="onRegenerateRecoveryCodes()"
            >
                Regenerate Recovery Codes
            </button>
        </p>
    </div>
</ng-container>
